import EmployeeLayout from '../../components/layout/EmployeeLayout';
import { FAQList } from '../../components/FAQList';

export default function EmployeeFAQPage() {
  return (
    <EmployeeLayout>
      <div className="p-4 sm:p-6 max-w-3xl mx-auto">
        <FAQList />
      </div>
    </EmployeeLayout>
  );
}
